import { FuzzyScore } from 'vscode/vscode/vs/base/common/filters';

class SimpleCompletionItem {
    constructor(completion) {
        this.completion = completion;
        this.score = FuzzyScore.Default;
        this.labelLow = this.completion.label.toLowerCase();
    }
}

export { SimpleCompletionItem };
